import React, { useEffect, useState, useRef } from 'react';
import {
  Table,
  Button,
  Dialog,
  Input,
  Form,
  DatePicker,
  Message,
  Card,
  Pagination,
  Select,
  TimePicker,
  CascaderSelect,
} from '@alifd/next';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import moment from 'moment';
import axios from 'axios';
import ezconImg from '../../../../../public/ezcon.png';
const { Item } = Form;
const Option = Select.Option;
const AccountingList = (props) => {
  const accounting = client.service('accounting');
  const [accountingArr, setAccountingArr] = useState([]);
  const [addAccountingDialog, setAddAccountingDialog] = useState(false);
  const [editAccountingDialog, setEditAccountingDialog] = useState(false);
  const [editAccountingIndex, setEditAccountingIndex] = useState(null);
  const [name, setName] = useState('');
  const [count, setCount] = useState('');
  const [price, setPrice] = useState('');
  const [sum, setSum] = useState('');
  const [overage, setOverage] = useState('');

  // 換頁
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = accountingArr.slice(indexOfFirstPost, indexOfLastPost);

  //查詢
  function accountingFind(para) {
    return new Promise((resolve, reject) => {
      try {
        accounting.find({ query: para }).then((result) => {
          resolve(result && result.data ? result.data : []);
        });
      } catch (error) {
        reject(error);
      }
    });
  }
  //新增
  function accountingCreate(obj) {
    return new Promise((resolve, reject) => {
      try {
        accounting.create(obj).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  //更新
  function accountingUpdate(id, obj) {
    return new Promise((resolve, reject) => {
      // console.log(id, obj, params)
      accounting
        .patch(id, obj)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  //刪除
  function accountingRemove(id) {
    return new Promise((resolve, reject) => {
      try {
        accounting.remove(id).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  // function householdNumberSort(a, b) {
  //   return a.building > b.building ? 1 : -1 && a.floor > b.floor ? 1 : -1 && a.floorChild > b.floorChild ? 1 : -1;
  // }
  //刷新頁面
  function serverDataUpdate() {
    accountingFind({}).then((result) => {
      setAccountingArr(result);
    });
  }

  useEffect(() => {
    serverDataUpdate();
  }, []);

  //編號
  function makeid(length) {
    let result = '';
    let characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  return (
    <>
      <Button
        className={styles.buttonAdd}
        onClick={() => {
          setAddAccountingDialog(true);
        }}
      >
        新增
      </Button>

      <Dialog
        hasMask
        className={styles.dialog}
        visible={addAccountingDialog}
        onOk={() => {
          accountingCreate({
            createdTime: new Date().toLocaleString(),
            updatedTime: new Date().toLocaleString(),
            summonsNumber: makeid(8),
            serialNumber: makeid(8),
            name: name,
            count: count,
            price: price,
            sum: sum,
            overage: overage,
          })
            .then((res) => {
              console.log('==accounting create success:', res);
              serverDataUpdate();

              setName('');
              setCount('');
              setPrice('');
              setSum('');
              setOverage('');
              setAddAccountingDialog(false);
            })
            .catch((error) => {
              console.log('==accounting create fail:', error);
            });
        }}
        onCancel={() => {
          setAddAccountingDialog(false);
        }}
        onClose={() => {
          setAddAccountingDialog(false);
        }}
      >
        <Form>
          <h3>新增銷貨收入</h3>

          <Item label="產品名稱">
            <Input
              name="name"
              placeholder="請輸入產品名稱"
              onChange={(value) => {
                // console.log('onChange', value);
                setName(value);
              }}
            />
          </Item>
          <Item label="數量">
            <Input
              name="count"
              placeholder="請輸入數量"
              onChange={(value) => {
                // console.log('onChange', value);
                setCount(value);
              }}
            />
          </Item>
          <Item label="單價">
            <Input
              name="price"
              placeholder="請輸入單價"
              onChange={(value) => {
                // console.log('onChange', value);
                setPrice(value);
              }}
            />
          </Item>
          <Item label="金額">
            <Input
              name="sum"
              placeholder="請輸入金額"
              onChange={(value) => {
                // console.log('onChange', value);
                setSum(value);
              }}
            />
          </Item>
          <Item label="餘額">
            <Input
              name="overage"
              placeholder="請輸入餘額"
              onChange={(value) => {
                // console.log('onChange', value);
                setOverage(value);
              }}
            />
          </Item>
        </Form>
      </Dialog>

      <Card free>
        <Card.Content>
          <Table dataSource={currentPosts}>
            <Table.Column
              title="建立時間"
              dataIndex="createdTime"
              width={150}
            />
            <Table.Column
              title="傳票編號"
              dataIndex="summonsNumber"
              width={150}
            />
            <Table.Column title="序號" dataIndex="serialNumber" width={150} />
            <Table.Column title="產品名稱" dataIndex="name" width={200} />
            {/* <Table.Column title="數量" dataIndex="count" width={400} />
            <Table.Column title="單價" dataIndex="price" width={150} />
            <Table.Column title="金額" dataIndex="sum" width={150} />
            <Table.Column title="餘額" dataIndex="overage" width={100} /> */}
            {/* <Table.Column title="更新時間" dataIndex="updatedTime" width={150} /> */}
          </Table>
          <br />
          <Pagination
            total={accountingArr.length}
            onChange={(pageNumber) => setCurrentPage(pageNumber)}
          />
        </Card.Content>
      </Card>
    </>
  );
};

export default AccountingList;
